module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Nenzlingen-8363c504c93fb31877cad7272cce3320.png";